module.exports = __webpack_public_path__ + "media/assets/images/logos/logo_banco_votorantim-ce2d91b354b43b40eccd456c58ce867e.png";